// extracted by mini-css-extract-plugin
export default {"employees-page":"EmployeesContainer_employees-page__3fKP-","employees-container":"EmployeesContainer_employees-container__Sa8T9"};